import { render, staticRenderFns } from "./WABAChannels.vue?vue&type=template&id=724c405e&scoped=true"
import script from "./WABAChannels.vue?vue&type=script&lang=js"
export * from "./WABAChannels.vue?vue&type=script&lang=js"
import style0 from "./WABAChannels.vue?vue&type=style&index=0&id=724c405e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724c405e",
  null
  
)

export default component.exports